import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import { Icon, Button, IconButton, Tooltip } from '@material-ui/core';
import ReactTable from "react-table";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../../auth/store/actions';
import * as TableActions from 'main/components/tableSort/store/actions';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import TabPanelButtons from '../../components/TabPanelButtons';
import * as HelperFunctions from '../../components/helpers'; 
import PageHeader from 'main/components/PageHeader';

const styles = theme => ({
    layoutRoot: {},
});

class AuthList extends Component {

    componentDidMount() {
        this.props.getAuthList();
    }

    handleRowClick(page_type, auth_id) {
        this.props.history.push(`/user/${page_type}/${auth_id}`);
    }

    activeColumn = (a) => {
        if (a.DeletedAt) {
            return null
        }
        return (
            <Icon>check_circle</Icon>
        )
    }

    companyColumn = (a) => {
        if (a.companies.length === 0) {
            return null
        }
        else if (a.companies.length === 1) {
            return a.companies[0].CompanyName
        }
        else {
            let compArr = a.companies.map(c => ` ${c.CompanyName}`);
            let compString = compArr.join();
            return compString.substring(0, compString.length - 1)
        }
    }

    roleColumn = (a) => {
        const roles = a.roles.map(r => r.RoleName);
        const uniqueRoles = Array.from(new Set(roles))
        return uniqueRoles.map(r => r + ' ')
    }

    render() {
        const { authList, classes, table_page_size, table_sort, table_filter, is_loaded } = this.props
        const table_name = this.constructor.name;

        if (!is_loaded) return <React.Fragment>Loading...</React.Fragment>;

        return (
            <FusePageCarded
                header={
                    <PageHeader
                        component_type = {"user"}
                        view_type      = {"list"}
                    />
                }
                contentToolbar={
                    <div className="px-24 flex flex-1 justify-end">
                        <TabPanelButtons
                            component_name = {"user"}
                            view_type      = {"list"}
                            button_list    = {[
                                {
                                    display: "Add",
                                    type:    "create",
                                    color:   "primary",
                                    onClick: () => this.props.history.push("/user/create"),
                                }
                            ]}
                        />
                    </div>
                }
                content={
                    <ReactTable
                        style={{ position: 'absolute' }}
                        columns={[
                            {
                                Header: "First",
                                accessor: "FirstName",
                                width: 200
                            },
                            {
                                Header: "Last",
                                accessor: "LastName",
                                width: 200
                            },
                            {
                                Header: "Email",
                                accessor: "Email"
                            },
                            {
                                Header: "Companies",
                                id: "Companies",
                                accessor: a => this.companyColumn(a)
                            },
                            {
                                Header: "Roles",
                                id: "Roles",
                                accessor: a => this.roleColumn(a)
                            },
                            {
                                Header: "Active",
                                id: "Active",
                                accessor: a => this.activeColumn(a),
                                width: 100
                            },
                            {
                                Header: "Actions",
                                maxWidth: 100,
                                Cell: row => (
                                    <div className="flex items-center">
                                        <Tooltip title="Detail">
                                            <IconButton
                                                style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                                onClick={(ev) => {
                                                    ev.stopPropagation();
                                                    this.handleRowClick('detail', row.original.auth_id);
                                                }}
                                            >
                                                <Icon>library_books</Icon>
                                            </IconButton>
                                        </Tooltip>
                                        {!HelperFunctions.checkPermission(this.props.auth.user.data.permissionList, "user", "edit") ? null :
                                            <Tooltip title="Edit">
                                                <IconButton
                                                    style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                                    onClick={(ev) => {
                                                        ev.stopPropagation();
                                                        this.handleRowClick('edit', row.original.auth_id);
                                                    }}
                                                >
                                                    <Icon>border_color</Icon>
                                                </IconButton>
                                            </Tooltip>
                                        }
                                    </div>
                                )
                            }
                        ]}
                        data={authList}
                        defaultPageSize={25}
                        pageSize={table_page_size[table_name]}
                        className="-striped -highlight"
                        noDataText="No Users Found"
                        defaultSorted={table_sort[table_name]}
                        onSortedChange={(sort_list) => this.props.setTableSort(this.props.auth.user.data.auth_id, table_name, sort_list)}
                        filterable={true}
                        defaultFiltered={table_filter[table_name]}
                        onFilteredChange={_.debounce((filter_list) => this.props.setTableFilter(this.props.auth.user.data.auth_id, table_name, filter_list), 500)}
                        onPageSizeChange={(page_size) => this.props.setTablePageSize(this.props.auth.user.data.auth_id, table_name, page_size)}
                    />
                }

            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getAuthList:      Actions.getAuthList,
        setTableSort:     TableActions.setTableSort,
        setTableFilter:   TableActions.setTableFilter,
        setTablePageSize: TableActions.setTablePageSize,

    }, dispatch);
}

function mapStateToProps({ tableSort, auth }) {
    return {
        table_sort:      tableSort.table_sort,
        authList:        auth.crud.authList,
        table_filter:    tableSort.table_filter,
        table_page_size: tableSort.table_page_size,
        is_loaded:       tableSort.is_loaded,
        auth,
    }
}


export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthList)));


// WEBPACK FOOTER //
// src/main/content/auth/AuthList.js